import { QueryOptions } from "../../components/Common/useQuery";
import useKaEmployeeQuery from "../../components/Common/useKaEmployeeQuery";

export interface SiteDto {
  id: string;
  customerName: string;
  internalName: string;
  internalSiteId: string;
}

export interface BusinessDto {
  id: string;
  name: string;
  serviceContractNumber: string;
  siteAllowance: number;
  disabled: boolean;
  sandbox: boolean;
  sites: SiteDto[];
}

const useGetBusinesses = (options?: QueryOptions<BusinessDto[]>) => {
  return useKaEmployeeQuery<BusinessDto[]>({ path: '/employeeApi/businesses' }, options);
}

export default useGetBusinesses;
